export {
    Tween,
    update,
}

const tweens = [];

const easingFunctions = {
    linear: t => t,
    easeInQuad: t => t*t,
    easeOutQuad: t => t*(2-t),
    easeInOutQuad: t => t<.5 ? 2*t*t : -1+(4-2*t)*t,
    easeInCubic: t => t*t*t,
    easeOutCubic: t => (--t)*t*t+1,
    easeInOutCubic: t => t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1,
    easeInQuart: t => t*t*t*t,
    easeOutQuart: t => 1-(--t)*t*t*t,
    easeInOutQuart: t => t<.5 ? 8*t*t*t*t : 1-8*(--t)*t*t*t,
    easeInQuint: t => t*t*t*t*t,
    easeOutQuint: t => 1+(--t)*t*t*t*t,
    easeInOutQuint: t => t<.5 ? 16*t*t*t*t*t : 1+16*(--t)*t*t*t*t,
};

function update(dt) {
    tweens.forEach(tween => tween.update(dt));
}

class Tween {
    // TODO: return a promise that resolves when the tween ends ?
    constructor(from, to, duration, easingFunction = 'linear', setFunction, callback) {
        this.type = typeof from;
        if (this.type === 'number') {
            this.from = from;
            this.to = to;
        } else if (this.type === 'object') {
            this.target = from;
            this.from = { ...from };
            this.to = to;
        }
        this.duration = duration;
        this.time = 0;
        this.easingFunction = easingFunctions[easingFunction];
        this.setFunction = setFunction;
        this.ended = false;
        this.callback = callback || this.dispose;
        tweens.push(this);
    }

    update(dt) {
        this.time += dt;

        if (this.time > this.duration) {
            this.time = this.duration;

            if (typeof this.callback === 'function' && !this.ended) this.callback(this);

            this.ended = true;
        }

        if (this.type === 'object') {
            for (const key in this.target) {
                this.target[key] = lerp(this.from[key], this.to[key], this.easingFunction(this.time / this.duration));
            }
        }

        if (this.setFunction) {
            if (this.type === 'object') {
                this.setFunction({ ...this.target });
            } else {
                this.setFunction(this.value());
            }
        }
    }

    value() {
        return lerp(this.from, this.to, this.easingFunction(this.time / this.duration));
    }

    dispose() {
        tweens.splice(tweens.indexOf(this), 1);
    }
}

function lerp(from, to, t) {
    return from + (to - from) * t;
}